{ "bip122:00000000001a91e3dace36e2be3bf030/slip44:3": "dogecoin" }
